/* eslint-disable max-len */
import React from 'react';

export const tableColumnsWithProps = (code, setFilters, setOpenOrders) => {
  return [
    {
      'Header': () => <span className="header-title ml-3 mr-3">FECHA</span>,
      'accessor': 'processDate',
      'Cell': ({row}) => {
        const {processDate} = row.original;
        return <div>{processDate && processDate.substring(0, 10)}</div>;
      },
    },
    {
      'Header': () => <span className=" ml-2 mr-2 header-title">CANTIDAD</span>,
      'accessor': 'labelsCount',
      'Cell': ({row}) => {
        const {labelsCount} = row.original;
        return (
          <div
            className='pointer text-primary'
            onClick={() => {
              setFilters({
                'filterKey': 'date',
                'filterValue': {
                  'orderType': code,
                  'date': row.original.processDate,
                },
              });
              setOpenOrders(false);
            }}
          >
            {labelsCount}
          </div>);
      },
    },
  ];
};
